import { PSection } from "@/commons/interface/speccommon/section";
import { StdResponse, bimAxios } from "@/config/axios";

export function getSystemSections(group: string, type: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sections`, {
        params: {
            ...params,
            group: group,
            type: type,
        }
    })
}
export function getSectionsByprojectUuid(projectUuid: string, majorUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/sections`, {
        params: {
            ...params,
            majorUuid: majorUuid
        }
    })
}
export function getSectionInfo(id: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sections/${id}`, {
        params: {
            ...params,
        }
    })
}
export function addProjectSection(projectUuid: string, sections: PSection[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/sections`, sections, {
        params: {
            ...params,
        }
    })
}
export function deleteProjectSection(projectUuid: string, id: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}/sections/${id}`, {
        params: {
            ...params,
        }
    })
}
export function getSystemSectionParamIns(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sections/param-in`, {
        params: {
            ...params,
        }
    })
}
export function addCustomSection(projectUuid: string, section: PSection, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/sections/custom`, section, {
        params: {
            ...params,
        }
    })
}
export function updateSection(id: string, section: PSection, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/sections/${id}`, section, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectSectionMulti(projectUuid: string, ids: string[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/sections/delete-multi`, ids, {
        params: {
            ...params,
        }
    })
}

export function checkSectionsHasBeenUsed(projectUuid: string, ids: string[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/sections/check-used`, ids, {
        params: {
            ...params,
        }
    })
}